import { Box, Button } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import visaeroImg from "../../assets/dashboard/header icon.svg";
import responsibleImg from "../../assets/landingScreen/Shared document icons (3).svg";
import minTransactionImg from "../../assets/landingScreen/Shared document icons.svg";
import autoPaymentImg from "../../assets/landingScreen/check document.svg";
import globalPayImg from "../../assets/landingScreen/g payment.svg";
import trackEarnImg from "../../assets/landingScreen/notes.svg";
import uniqueId from "../../assets/landingScreen/porson.svg";
import sameStyle from "../../components/customerBenefits/index.module.css";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfileDetails } from "../../redux/features/getUserProfile";

const Data = [
  {
    name: "Minimum transaction size is 100 per year",
    img: minTransactionImg,
  },
  {
    name: "Automatic payment to your bank account",
    img: autoPaymentImg,
  },
  {
    name: "Your VisaLancer ID is unique to you and not transferable",
    img: uniqueId,
  },
  {
    name: "Track your transactions and earnings",
    img: trackEarnImg,
  },
  {
    name: "Visaero reserves the right to continue, amend, update or terminate the program",
    img: visaeroImg,
  },
  {
    name: "VisaLancer is responsible for complying with any applicable regulations and laws",
    img: responsibleImg,
  },
  {
    name: "Global payment gateway integrated for your Global Customers.",
    img: globalPayImg,
  },
];
export default function Acknowledge() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const user_id = localStorage.getItem("userId");
  const userDetails = useSelector((state) => state.userProfile?.result?.data);


  useEffect(() => {
    dispatch(getUserProfileDetails(user_id));
  }, [user_id]);

  return (
    <>
      <Box
        style={{
          backgroundColor: "#F07821",
          padding: "0.7rem 1rem",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={visaeroImg} style={{ width: "1.5rem" }} />
      </Box>
      <Box sx={{ margin: "1rem" }}>
        <Box>
          <h4
            className={sameStyle.header}
            style={{ textTransform: "capitalize" }}
          >
            Welcome {userDetails?.first_name},
          </h4>
          <p className={sameStyle.header_desc}>
            Check out the highlights of an e-Visa VisaLancer
          </p>
        </Box>
        <Box className={sameStyle.items_container}>
          {Data?.map((item, index) => {
            const { name, img } = item;
            return (
              <Box key={index} className={sameStyle.item_box}>
                <Box className={sameStyle.item_box_imageSection}>
                  <img src={img} />
                </Box>
                <h4>{name}</h4>
              </Box>
            );
          })}

          <Box
            className={sameStyle.shareButton}
            sx={{ backgroundColor: "#8647AF" }}
            onClick={() => navigate("/add-to-home")}
          >
            I Acknowledge
          </Box>
        </Box>
      </Box>
    </>
  );
}
